import React from 'react';
import PropTypes from 'prop-types';
import {theme} from '../../themes/theme';

export const Corner = ({selected}) => {
	return (
		<svg width="14" height="42" viewBox="0 0 14 42" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 0L14 9.5V42H0V0Z" fill={selected ? theme.colors.forecastPurple : '#DDDDDD'} />
			<path d="M0 1L13 10V41H0V1Z" />
		</svg>
	);
};

Corner.propTypes = {
	/**
	 * The element is checked or not.
	 */
	selected: PropTypes.bool,
};
